import {IOfferTag} from "../types/IOfferTag";

interface IValueLabel {
    label: string;
    value: number;
}

interface IVariables {
    offer_facilities: IValueLabel[];
    offer_natural_sites: IValueLabel[];
    offer_standard_description_type: IValueLabel[];
}

interface IGroupedAmenities {
    standardAndSafety: IAmenities;
    energy: IAmenities;
    recreation: IAmenities;
    nature: IAmenities;
    services: IAmenities;
}

export interface IAmenities {
    label: string;
    amenities: IValueLabel[];
}

enum FacilitiesStandardAndSafety {
    SECURITY = 2,
    MONITORING = 6,
    FENCED = 7,
    CONCIERGE = 8,
    RECEPTION = 16,
    ELEVATOR = 20,
    BIKE_PARKING = 22,
    STROLLER_ROOM = 28
}

enum FacilitiesEnergy {
    AIR_CONDITIONING = 12,
    SMART_HOUSE = 23,
    PHOTOVOLTAICS = 30,
    CAR_CHARGER = 31,
    RECUPERATION = 32,
    HEAT_PUMP = 33
}

enum FacilitiesRecreation {
    OUTDOOR_GYM = 26,
    FITNESS_ROOM = 27,
    PLAYING_FIELD = 10,
    TENNIS = 14,
    POOL = 9,
    SAUNA = 17,
    PLAYGROUND = 3,
    WATER_BATH = 1
}

enum OfferTags {
    PARKS_NEARBY = 44
}

enum NaturalSiteFacilities {
    FOREST = 2,
    LAKE = 3,
    PARK = 7,
    SEA = 6
}

enum ServicesFacilities {
    PARCEL_LOCKER = 35
}

const standardAndSafetyAmenitiesValue = [
    FacilitiesStandardAndSafety.MONITORING,
    FacilitiesStandardAndSafety.SECURITY,
    FacilitiesStandardAndSafety.FENCED,
    FacilitiesStandardAndSafety.RECEPTION,
    FacilitiesStandardAndSafety.BIKE_PARKING,
    FacilitiesStandardAndSafety.ELEVATOR,
    FacilitiesStandardAndSafety.CONCIERGE,
    FacilitiesStandardAndSafety.STROLLER_ROOM
];

const energyAmenitiesValue = [
    FacilitiesEnergy.PHOTOVOLTAICS,
    FacilitiesEnergy.RECUPERATION,
    FacilitiesEnergy.HEAT_PUMP,
    FacilitiesEnergy.AIR_CONDITIONING,
    FacilitiesEnergy.CAR_CHARGER,
    FacilitiesEnergy.SMART_HOUSE
];

const recreationAmenitiesValue = [
    FacilitiesRecreation.OUTDOOR_GYM,
    FacilitiesRecreation.FITNESS_ROOM,
    FacilitiesRecreation.PLAYING_FIELD,
    FacilitiesRecreation.TENNIS,
    FacilitiesRecreation.POOL,
    FacilitiesRecreation.SAUNA,
    FacilitiesRecreation.PLAYGROUND,
    FacilitiesRecreation.WATER_BATH
];

const natureAmenitiesValue = [NaturalSiteFacilities.FOREST, NaturalSiteFacilities.LAKE, NaturalSiteFacilities.PARK, NaturalSiteFacilities.SEA];

const servicesAmenitiesValue = [ServicesFacilities.PARCEL_LOCKER];

export const getOfferAmenities = (
    offerFacilities: number[] | null,
    naturalSites: number[] | null,
    nearbyParksTag: IOfferTag[] | null,
    standardType: number[] | null,
    variables: IVariables | null
) => {
    const groupedAmenitiesObject: IGroupedAmenities = {
        standardAndSafety: {
            label: "Standard i bezpieczeństwo",
            amenities: []
        },
        energy: {
            label: "Instalacje i energetyka",
            amenities: []
        },
        recreation: {
            label: "Rekreacja",
            amenities: []
        },
        nature: {
            label: "Przyroda w okolicy",
            amenities: []
        },
        services: {
            label: "Usługi na terenie osiedla",
            amenities: []
        }
    };

    const filterAndPushAmenity = (el: number, objectKey: keyof IGroupedAmenities, variableKey: keyof IVariables) => {
        if (!variables) {
            return;
        }

        const fullAmenityName = variables[variableKey].filter((facility) => facility.value === el);
        groupedAmenitiesObject[objectKey].amenities.push(...fullAmenityName);
    };

    if (offerFacilities && variables?.offer_facilities) {
        offerFacilities.forEach((el) => {
            if (standardAndSafetyAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "standardAndSafety", "offer_facilities");
            } else if (energyAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "energy", "offer_facilities");
            } else if (recreationAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "recreation", "offer_facilities");
            } else if (servicesAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "services", "offer_facilities");
            }
        });
    }

    // additional value for standardAndSafety which is not in offerFacilities
    if (standardType && variables?.offer_standard_description_type) {
        standardType.forEach((el) => {
            filterAndPushAmenity(el, "standardAndSafety", "offer_standard_description_type");
        });
    }

    //information about nearby parks
    if (nearbyParksTag && nearbyParksTag?.length > 0) {
        //Tags have different structure, at this moment it is necessary to normalize this
        if (nearbyParksTag[0].description && nearbyParksTag[0].id === OfferTags.PARKS_NEARBY) {
            const serializedParkInfo: IValueLabel = {
                label: nearbyParksTag[0].description,
                value: nearbyParksTag[0].id
            };

            groupedAmenitiesObject.nature.amenities.push(...[serializedParkInfo]);
        }
    }

    // natural places around investment
    if (naturalSites && variables?.offer_natural_sites) {
        naturalSites.forEach((el) => {
            if (natureAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "nature", "offer_natural_sites");
            }
        });
    }

    // replace object to react friendly array
    let groupedAmenitiesArray: IAmenities[] = [];
    let key: keyof IGroupedAmenities;

    for (key in groupedAmenitiesObject) {
        if (groupedAmenitiesObject[key].amenities.length > 0) {
            groupedAmenitiesArray = [...groupedAmenitiesArray, groupedAmenitiesObject[key]];
        }
    }

    return groupedAmenitiesArray;
};
import {IOfferTag} from "../types/IOfferTag";

interface IValueLabel {
    label: string;
    value: number;
}

interface IVariables {
    offer_facilities: IValueLabel[];
    offer_natural_sites: IValueLabel[];
    offer_standard_description_type: IValueLabel[];
}

interface IGroupedAmenities {
    standardAndSafety: IAmenities;
    energy: IAmenities;
    recreation: IAmenities;
    nature: IAmenities;
    services: IAmenities;
}

export interface IAmenities {
    label: string;
    amenities: IValueLabel[];
}

enum FacilitiesStandardAndSafety {
    SECURITY = 2,
    MONITORING = 6,
    FENCED = 7,
    CONCIERGE = 8,
    RECEPTION = 16,
    ELEVATOR = 20,
    BIKE_PARKING = 22,
    STROLLER_ROOM = 28
}

enum FacilitiesEnergy {
    AIR_CONDITIONING = 12,
    SMART_HOUSE = 23,
    PHOTOVOLTAICS = 30,
    CAR_CHARGER = 31,
    RECUPERATION = 32,
    HEAT_PUMP = 33
}

enum FacilitiesRecreation {
    OUTDOOR_GYM = 26,
    FITNESS_ROOM = 27,
    PLAYING_FIELD = 10,
    TENNIS = 14,
    POOL = 9,
    SAUNA = 17,
    PLAYGROUND = 3,
    WATER_BATH = 1
}

enum OfferTags {
    PARKS_NEARBY = 44
}

enum NaturalSiteFacilities {
    FOREST = 2,
    LAKE = 3,
    PARK = 7,
    SEA = 6
}

enum ServicesFacilities {
    PARCEL_LOCKER = 35
}

const standardAndSafetyAmenitiesValue = [
    FacilitiesStandardAndSafety.MONITORING,
    FacilitiesStandardAndSafety.SECURITY,
    FacilitiesStandardAndSafety.FENCED,
    FacilitiesStandardAndSafety.RECEPTION,
    FacilitiesStandardAndSafety.BIKE_PARKING,
    FacilitiesStandardAndSafety.ELEVATOR,
    FacilitiesStandardAndSafety.CONCIERGE,
    FacilitiesStandardAndSafety.STROLLER_ROOM
];

const energyAmenitiesValue = [
    FacilitiesEnergy.PHOTOVOLTAICS,
    FacilitiesEnergy.RECUPERATION,
    FacilitiesEnergy.HEAT_PUMP,
    FacilitiesEnergy.AIR_CONDITIONING,
    FacilitiesEnergy.CAR_CHARGER,
    FacilitiesEnergy.SMART_HOUSE
];

const recreationAmenitiesValue = [
    FacilitiesRecreation.OUTDOOR_GYM,
    FacilitiesRecreation.FITNESS_ROOM,
    FacilitiesRecreation.PLAYING_FIELD,
    FacilitiesRecreation.TENNIS,
    FacilitiesRecreation.POOL,
    FacilitiesRecreation.SAUNA,
    FacilitiesRecreation.PLAYGROUND,
    FacilitiesRecreation.WATER_BATH
];

const natureAmenitiesValue = [NaturalSiteFacilities.FOREST, NaturalSiteFacilities.LAKE, NaturalSiteFacilities.PARK, NaturalSiteFacilities.SEA];

const servicesAmenitiesValue = [ServicesFacilities.PARCEL_LOCKER];

export const getOfferAmenities = (
    offerFacilities: number[] | null,
    naturalSites: number[] | null,
    nearbyParksTag: IOfferTag[] | null,
    standardType: number[] | null,
    variables: IVariables | null
) => {
    const groupedAmenitiesObject: IGroupedAmenities = {
        standardAndSafety: {
            label: "Standard i bezpieczeństwo",
            amenities: []
        },
        energy: {
            label: "Instalacje i energetyka",
            amenities: []
        },
        recreation: {
            label: "Rekreacja",
            amenities: []
        },
        nature: {
            label: "Przyroda w okolicy",
            amenities: []
        },
        services: {
            label: "Usługi na terenie osiedla",
            amenities: []
        }
    };

    const filterAndPushAmenity = (el: number, objectKey: keyof IGroupedAmenities, variableKey: keyof IVariables) => {
        if (!variables) {
            return;
        }

        const fullAmenityName = variables[variableKey].filter((facility) => facility.value === el);
        groupedAmenitiesObject[objectKey].amenities.push(...fullAmenityName);
    };

    if (offerFacilities && variables?.offer_facilities) {
        offerFacilities.forEach((el) => {
            if (standardAndSafetyAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "standardAndSafety", "offer_facilities");
            } else if (energyAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "energy", "offer_facilities");
            } else if (recreationAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "recreation", "offer_facilities");
            } else if (servicesAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "services", "offer_facilities");
            }
        });
    }

    // additional value for standardAndSafety which is not in offerFacilities
    if (standardType && variables?.offer_standard_description_type) {
        standardType.forEach((el) => {
            filterAndPushAmenity(el, "standardAndSafety", "offer_standard_description_type");
        });
    }

    //information about nearby parks
    if (nearbyParksTag && nearbyParksTag?.length > 0) {
        //Tags have different structure, at this moment it is necessary to normalize this
        if (nearbyParksTag[0].description && nearbyParksTag[0].id === OfferTags.PARKS_NEARBY) {
            const serializedParkInfo: IValueLabel = {
                label: nearbyParksTag[0].description,
                value: nearbyParksTag[0].id
            };

            groupedAmenitiesObject.nature.amenities.push(...[serializedParkInfo]);
        }
    }

    // natural places around investment
    if (naturalSites && variables?.offer_natural_sites) {
        naturalSites.forEach((el) => {
            if (natureAmenitiesValue.includes(el)) {
                filterAndPushAmenity(el, "nature", "offer_natural_sites");
            }
        });
    }

    // replace object to react friendly array
    let groupedAmenitiesArray: IAmenities[] = [];
    let key: keyof IGroupedAmenities;

    for (key in groupedAmenitiesObject) {
        if (groupedAmenitiesObject[key].amenities.length > 0) {
            groupedAmenitiesArray = [...groupedAmenitiesArray, groupedAmenitiesObject[key]];
        }
    }

    return groupedAmenitiesArray;
};
